import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img
              src="/images/logo.png"
              alt="Never Better Logo"
              className="logo-img"
            />
          </Link>
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
          <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
          <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
        </div>

        <nav className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <ul>
            <li>
              <NavLink to="/" onClick={closeMenu}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/gallery" onClick={closeMenu}>
                Gallery
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={closeMenu}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to="/services" onClick={closeMenu}>
                Services
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className="cta-button"
                onClick={closeMenu}
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;